import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-base-home',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './base-home.template.component.html',
  styleUrls: ['./base-home.template.component.scss']
})
export class SkeletorBaseHomeTemplateComponent {
  @Input() items: number = 8;
  get rows() { return Array.from({ length: this.items }); }
  barHeights = [80, 120, 60, 140, 100, 130, 90, 110, 70, 150, 95, 125];
}
